import React, { useEffect } from 'react'
import FileManager from 'devextreme-react/file-manager'
import RemoteFileSystemProvider from 'devextreme/file_management/remote_provider'

export default function Sharepoint() {
	useEffect(() => {
		document.title = 'Fiber :: Sharepoint'
	}, [])

	const remoteFileProvider = new RemoteFileSystemProvider({
		endpointUrl: `${API_FIBER_URL}/sharepoint/file-system`,
		beforeAjaxSend: function ({ headers, formData, xhrFields }) {
			xhrFields.withCredentials = true
		},
	})

	return <FileManager fileSystemProvider={remoteFileProvider}></FileManager>
}
